<template>
  <!-- 商品选择，用于table列表，比如销售单,v-model必须是array，必须有一个字段叫skuId和productName, 调用组件：1进行主商品单选 toSelectSingle， 2 进行主商品多选 toSelectMore -->
  <div :class="showListTable? 'product-select-table': 'product-select-table display-not'" :style="{'height': height}">
    <yq-table ref="yqTable" :data="dataList" border stripe v-show="showListTable" :empty-text="emptyText" :height="height">
      <yq-table-column label="商品名称" prop="productName">
        <template v-slot="{row,$index}">
          <div v-if="disabled">
            {{row.productName}}
          </div>
          <div v-else>
            <el-input :id="`inputOver${$index}`" v-model="row.productName" @blur="inputBlur" @click.stop="toSelectMore(row, $index)" placeholder="请选择商品"/>
          </div>
        </template>
      </yq-table-column>
      <slot></slot>
    </yq-table>
    <el-dialog v-model="showSelect" dialog-width="3" :title="title" :close-on-click-modal="false">

      <dialog-table>
        <separator-page :show-shadow="false" :show-border="true">
          <template #category>
            <tree-dictionary @clickCategory="clickCategory" v-model:dictionary-list="productCategoryList"  :query-function="categoryQuery" :delete-function="categoryDelete" :save-function="categorySave" :disabled="true" />
          </template>
          <template #default>
            <list-page>
              <search-condition :mini-show-count="3" :show-border="false" :show-shadow="false">
                <el-input v-model="searchInfo.searchKey" placeholder="商品名称/商品编码" clearable>
                  <template #prefix>搜索</template>
                </el-input>
                <el-select v-model="searchInfo.searchType" clearable placeholder="请选择">
                  <template #prefix>商品类型</template>
                  <el-option v-for="(type, index) in productTypeList" :key="index" :value="type.code" :label="type.name"/>
                </el-select>
                <el-select v-model="searchInfo.status" placeholder="请选择">
                  <template #prefix>商品状态</template>
                  <el-option label="上架" :value="1"/>
                  <el-option label="下架" :value="0"/>
                </el-select>
                <template #option>
                  <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
                  <page-button el-type="primary" @click="searchInfo = {}">重置</page-button>
                </template>
              </search-condition>
              <list-table>
                <!-- 多选 -->
                <yq-table :data="dialogList" height="100%" border stripe row-key="id" :lazy="true" @row-dblclick="selectMainProduct" :highlight-current-row="true" :current-row-key="dialogListCurrentRow" @selectionChange="mainTableSelectionChange" page-name="productInfo">
                  <yq-table-column fixed="left" prop="selection" type="selection" width="60rem" align="center" v-if="multi && selectModel === 1"/>
                  <yq-table-column label="商品图片" prop="titleImage" min-width="80rem" type="index" align="center" fixed="left">
                    <template v-slot="{row}">
                      <image-show v-model="row.image" width="0.8rem" height="0.8rem" :limit="1"/>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="商品名称" prop="productName" min-width="180rem" :show-overflow-tooltip="true" fixed="left">
                    <template v-slot="{row}"><span :class="!row.hasChildren? 'product-name-no-children': ''">{{row.productName}}</span></template>
                  </yq-table-column>
                  <!-- 规格型号：与商品管理列表保持一致，紧跟商品名称 -->
                  <yq-table-column label="规格型号" prop="spec" min-width="160rem" :show-overflow-tooltip="true" fixed="left"/>
                  <yq-table-column label="商品编码" prop="productCodeBase" width="120rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="拼音码" prop="pinyinCode" width="120rem" :show-overflow-tooltip="true"/>
                  <yq-table-column v-if="showCostPrice" label="预设进价" prop="buyPriceBase" width="120rem" :show-overflow-tooltip="true" align="right">
                    <template v-slot="{row}"><money v-model="row.buyPriceBase"/> </template>
                  </yq-table-column>
                  <yq-table-column label="预设售价" prop="salePriceBase" width="120px" :show-overflow-tooltip="true" align="right">
                    <template v-slot="{row}"><money v-model="row.salePriceBase"/> </template>
                  </yq-table-column>
                  <yq-table-column label="商品分类" prop="categoryId" width="180rem" :show-overflow-tooltip="true">
                    <template v-slot="{row}">
                      <dictionary :dictionaries="productCategoryList" v-model="row.categoryId" :disabled="true"/>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="商品类型" prop="productType" width="120rem" :show-overflow-tooltip="true">
                    <template v-slot="{row}">
                      <span v-for="(it,id) in productTypeList" :key="id">
                        <span v-if="it.code === row.productType">{{it.name}}</span>
                      </span>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="商品单位" prop="unitNameBase" width="120rem" :show-overflow-tooltip="true" align="center">
                    <template v-slot="{row}">
                      <span v-for="u in unitList" :key="u.dictCode">
                        <el-tag v-if="u.dictCode === row.unitIdBase" type="success" size="small">{{u.dictName}}</el-tag>
                      </span>
                      <span v-for="u in unitList" :key="u.dictCode">
                        <el-tag v-if="u.dictCode === row.unitIdMiddle" type="primary" size="small">{{u.dictName}}</el-tag>
                      </span>
                      <span v-for="u in unitList" :key="u.dictCode">
                        <el-tag v-if="u.dictCode === row.unitIdLarge" type="warning" size="small">{{u.dictName}}</el-tag>
                      </span>
                    </template>
                  </yq-table-column>
                  <yq-table-column v-if="selectModel === 2 || !multi" fixed="right" label="操作" align="center">
                    <template v-slot="{row}">
                      <table-button @click="selectMainProduct(row)">选择</table-button>
                    </template>
                  </yq-table-column>
                </yq-table>
              </list-table>
              <form-page v-model:page-size="searchInfo.pageSize" v-model:page-number="searchInfo.pageNumber" :total-count="searchInfo.totalCount" @onLoad="queryList" :default-load="true" :show-border="false" :show-shadow="false">
                <span class="tips">不支持翻页选中</span>
                <page-button @click="showSelect = false">取消</page-button>
                <page-button v-if="!multi && selectModel === 2" @click="selectMainProduct({})" el-type="danger">清空</page-button>
                <page-button type="read" el-type="primary"  v-if="multi && selectModel === 1" @click="selectProductList">确定</page-button>
              </form-page>
            </list-page>
          </template>
        </separator-page>
      </dialog-table>


    </el-dialog>
    <!-- popover的table, 点击事件，取消input的失去焦点 -->
    <div class="pop-overlay" :id="popTableId" v-show="popTableShow" @click.stop="inputBlur2">
      <div class="pop-over-table">
        <yq-table :data="productList" border stripe height="100%" class="dialog-table-border" :highlight-current-row="true" :current-row-key="popTableCurrentRow" row-key="id" ref="popoverTable">
          <template #empty>
            <yq-icon v-if="loading" class="is-loading" name="element-ui_loading"/>
            <yq-empty description="暂无数据"/>
          </template>
          <el-table-column prop="selection" v-if="multi" width="60px" fixed="left" align="center">
            <template #header>
              <el-checkbox v-model="popoverCheckAll" :indeterminate="popoverIndeterminate" @change="changeInputCheckAll"/>
            </template>
            <template v-slot="{row}">
              <el-checkbox v-model="row.checked"/>
            </template>
          </el-table-column>
          <yq-table-column label="商品名称" prop="productName" :show-overflow-tooltip="true" />
          <yq-table-column label="规格" prop="productStandard" width="120rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="商品编码" prop="productCode" width="120rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="商品类型" prop="productType" width="120rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">
                      <span v-for="(it,id) in productTypeList" :key="id">
                        <span v-if="it.code === row.productType">{{it.name}}</span>
                      </span>
            </template>
          </yq-table-column>
          <yq-table-column label="商品分类" prop="productCategory" width="180rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">
              <dictionary :dictionaries="productCategoryList" v-model="row.productCategory" :disabled="true"/>
            </template>
          </yq-table-column>
          <yq-table-column v-if="showCostPrice" label="商品进价" prop="price" width="120px" fixed="right">
            <template v-slot="{row}">
              <div class="price-rate">
                <money v-model="row.buyPriceSmallTax"/>/{{row.unitNameSmall}}
              </div>
              <div class="price-not-rate">
                <money v-model="row.buyPriceSmall"/>/{{row.unitNameSmall}}
              </div>
            </template>
          </yq-table-column>
          <yq-table-column label="商品售价" prop="salePrice" width="120px" fixed="right">
            <template v-slot="{row}">
              <div class="price-rate">
                <money v-model="row.salePriceSmallTax"/>/{{row.unitNameSmall}}
              </div>
              <div class="price-not-rate">
                <money v-model="row.salePriceSmall"/>/{{row.unitNameSmall}}
              </div>

            </template>
          </yq-table-column>
        </yq-table>
      </div>
      <form-page :show-page="false">
        <template #left>
          <span class="tips">使用上下键选择商品，ctrl键进行选中，回车键进行确认</span>
        </template>
        <page-button @click="inputSelectDataBlur">取消</page-button>
        <page-button el-type="primary" @click="inputEnterSelectMulti(dataListCurrentRowIndex)">确定</page-button>
      </form-page>
    </div>
  </div>
</template>

<script>

import {watch} from "vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import Dictionary from "@/components/h5/data/Dictionary.vue";
import commonApi from "@/api/commonApi";
import Money from "@/components/h5/data/Money.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import commonProductApi from "@/api/normal/common/commonDataApi";
import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
export default {
  // tableSelectOne, tableSelectMulti 在列表中选中一个or多个数据，这个数据已经更新上去了，可能需要调整数据显示, 数据只会添加skuId和productName两个字段，其它的商品信息放在productInfo下面
  // selectOne 选中一个商品，这个数据没有更新上去，需要自己更新
  // toSelectMore显示商品列表
  emits: ["tableSelectOne", "tableSelectMulti", "selectOne"],
  // v-model必须是array，必须有一个字段叫skuId和productName
  props: {
    height: {default: "100%", type: String},
    modelValue: {default: []},
    multi: {default: false}, // 是否多选
    title: {default: "选择商品"},
    repeatAble: {default: false}, // 是否可以重复添加
    showListTable: {default: true}, // 显示商品列表
    disabled: {default: false}, // 禁用
    queryApi: {default: null},
    emptyText: {default: "暂无数据"},
    showCostPrice: {default: true}, // 是否显示成本价
    beforeSelect: {default: null}, // 在添加商品前，进行什么操作，用于一些必要条件的限制，需自定义，通过返回true/false来控制是否添加
  },
  computed: {

  },
  name: "ProductSelectTable",
  components: {
    YqIcon,
    SearchCondition,
    PageButton,
    ListPage,
    TableButton,
    ImageShow,
    ListTable,
    TreeDictionary,
    DialogTable,
    SeparatorPage,
    Dictionary, FormPage, Money
  },
  data() {
    return {
      searchInfo: {},
      dialogList: [], // 显示在列表中的数据列表
      dialogSelected: [], // 显示在主商品列表中的，已被选中的数据
      dialogListCurrentRow: "", // dialog当前选中的商品
      dataList: [], // 选中的，列表中的数据
      dataListCurrentRowIndex: -1, // 列表数据，当前正在编辑的是哪条
      productList: [], // 商品列表，待选择的数据
      productCategoryList: [],
      productTypeList: [],
      bradeList: [],
      loading: false, // 正在加载数据
      showSelect: false,
      popTableCurrentRow: "", // popover当前选中行
      popSearchKey: undefined, // popover的查询条件
      popoverCheckAll: false, // popover选择全部
      popoverIndeterminate: true, // popover选中全部
      selectModel: 1, // 商品选择的模式，1选择列表的商品，2选择主商品
      popTableShow: false, // 是否显示popTable
      popTableId: "",
      inputBlurEvent: false,
      querySkuApi: null, // 查询接口,默认是查询商品sku接口
      produceMerchantList: [],
      unitList: [], // 商品单位
      // 商品分类的接口
      categoryQuery: null,
      categorySave: null,
      categoryDelete: null,
    };
  },
  created() {
    this.querySkuApi = this.queryApi? this.queryApi: commonProductApi.queryProductList; // 查询商品SKU的接口
    this.popTableId = "popTable_" + (Math.random() * 9999).toFixed(0);
    // 商品分类
    this.categoryQuery = this.getProductCategory; // 按权限查询
    this.categoryDelete = this.deleteCategory; // 删除唯一字典
    this.categorySave = dictionaryApi.saveUniqueTreeNode; // 保存唯一字典
    // 品牌
    // commonProductApi.queryBradeList("PRODUCT_BRADE").then(list => this.bradeList = list);
    // 商品生产企业
    // commonApi.queryDictionaryList("PRODUCT_MERCHANT").then(list => {this.produceMerchantList = list;});
    commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(list => this.unitList = list);
    // 获取系统配置 商品类型配置
    util.getSystemSettingOptions("PRODUCT_STOCK_TYPE").then(list => this.productTypeList = list);
    this.init();
    for (let i = 0; i < 20; i++) {
      // this.productList.push({productName: "商品1", unitName: "单位1"})
    }
    watch(() => this.modelValue, () => this.init());
  },
  mounted() {

    // 当整个组件渲染完成，将其添加到body
    this.$nextTick(() => {
      const body = document.querySelector('body')
      // 将匹配DOM添加到body中
      if (body.append) {
        body.append(document.querySelector("#" + this.popTableId));
      } else {
        body.appendChild(document.querySelector("#" + this.popTableId))
      }
    });
    // body 元素监听，用于监听点击事件，如果点击的不是当前元素，则关闭当前元素
    document.querySelector('body').addEventListener('click', this.inputSelectDataBlur);
  },
  unmounted() {
    const body = document.querySelector('body')
    body.removeChild(document.querySelector("#" + this.popTableId))
    // 移除body元素监听
    body.removeEventListener('click', this.inputSelectDataBlur);
  },
  methods: {

    getProductCategory() {
      return new Promise((resolve) => {
        commonApi.queryDictionaryTree("PRODUCT_CATEGORY").then(list => resolve(list));
      })
    },
    deleteCategory(id) {
      return new Promise((resolve) => {
        dictionaryApi.deleteUnique("PRODUCT_CATEGORY", id).then(() => {
          resolve();
        })
      })
    },
    init() {
      this.dataList = this.modelValue;
    },
    // 显示商品选择功能，用于选择主商品或多个商品
    toSelectSingle() {
      this.selectModel = 2;
      this.showSelect = true;
    },
    // 显示多选
    toSelectMore(row, index) {
      if (this.beforeSelect) {
        // 定义了显示前操作，但返回了false
        if (!this.beforeSelect()) {
          return;
        }
      }
      this.selectModel = 1; // 数据选择方式，1选择列表的商品，2选择主商品
      this.showSelect = true;
      this.dataListCurrentRowIndex = index;
    },
    // 选择多个商品
    selectProductList() {
      // 选中多个商品
      this.selectProductListReturn(this.dataListCurrentRowIndex, this.dialogSelected);
      this.showSelect = false;
    },
    // input按下enter，进行单选
    inputEnterSelectSingle(index) {
      for (let i = 0; i < this.productList.length; i++) {
        if (this.popTableCurrentRow === this.productList[i].id) {
          // 选中
          this.dataList[index] = {
            ...this.dataList[index],
            skuId: this.productList[i].id,
            productName: this.productList[i].productName,
          }
          this.inputSelectDataBlur();
          // 事件响应
          this.$emit("tableSelectOne", this.dataList[index], index);
          break;
        }
      }
    },
    // input框失去焦点时，准备关闭弹框
    inputBlur() {
      this.inputBlurEvent = true; // 标记失去焦点事件
      setTimeout(() => {
        if (this.inputBlurEvent) {
          this.popTableShow = false;
        }
      }, 200);
    },
    inputBlur2() {
      this.inputBlurEvent = false;
    },
    // popover输入框选中数据，关闭弹框
    inputSelectDataBlur() {
      this.popTableShow = false;
    },
    selectProductListReturn(index, arr) {
      let selected = [];
      let repeat = 0;
      for (let i = 0; i < arr.length; i++) {
        if (this.repeatAble) {
          // 可以重复添加
          selected.push(arr[i]);
        } else {
          // 看是否有重复，有重复就不添加
          // 不能重复添加，去重
          let contains = false;
          for (let j = 0; j < this.dataList.length; j++) {
            if (arr[i].id === this.dataList[j].skuId) {
              contains = true;
              repeat++;
              break;
            }
          }
          // 不存在重复的数据，添加到选中的数据中
          if (!contains) {
            selected.push(arr[i]);
          }
        }
      }
      if (repeat > 0) {
        this.$message.warning(`${repeat}条重复数据已忽略`)
      }
      if (selected.length === 0) {
        // 没有选中数据
        this.inputSelectDataBlur();
        return;
      }
      // 当前行的数据，清掉商品信息
      let thisRow = {...this.dataList[index]};
      // 如果没有选中，就清空
      let contains = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === thisRow.skuId) {
          contains = true;
          break;
        }
      }
      if (!contains) {
        thisRow.skuId = "";
        thisRow.productName = "";
      }
      this.dataList[index] = thisRow;
      // 多余的数据，添加到列表中去
      for (let i = 0; i < selected.length; i++) {
        // 添加到空白数据列，如果没有空白数据列，push
        let hasEmpty = false;
        for (let j = 0; j < this.dataList.length; j++) {
          if (!this.dataList[j].skuId) {
            this.dataList[j] = {
              ...this.dataList[j],
              skuId: selected[i].id,
              productName: selected[i].productName,
              productInfo: selected[i]
            };
            hasEmpty = true;
            break;
          }
        }
        if (!hasEmpty) {
          this.dataList.push({
            skuId: selected[i].id,
            productName: selected[i].productName,
            productInfo: selected[i]
          });
        }
      }
      this.inputSelectDataBlur(); // 关闭弹框
      this.$emit("tableSelectMulti", selected);
      // 刷新页面数据显示
      this.$refs.yqTable.showDataColumns();
    },
    refresh() {
      // 刷新页面数据显示
      this.$refs.yqTable.showDataColumns();
    },
    // input按下enter，进行多选
    inputEnterSelectMulti(index) {
      let arr = [];
      for (let i = 0; i < this.productList.length; i++) {
        if (!this.productList[i].checked) {
          continue;
        }
        arr.push(this.productList[i]);
      }
      this.selectProductListReturn(index, arr);
    },
    // 键盘按下，用于选择
    inputKeyDown(event, index) {
      if (event.keyCode === 13) {
        // enter 选中数据
        if (!this.multi) {
          // 只能单选
          this.inputEnterSelectSingle(index);
        } else {
          // 多选
          this.inputEnterSelectMulti(index);
        }
      } else if (event.keyCode === 17) {
        // ctrl，找到数据
        if (this.multi) {
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i].id === this.popTableCurrentRow) {
              this.productList[i].checked = !this.productList[i].checked;
              break;
            }
          }
          // 是否选中了全部
          let count = 0;
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i].checked) {
              count ++;
            }
          }
          this.popoverCheckAll = count > 0;
          this.popoverIndeterminate = count < this.productList.length && count > 0;
        }
      } else if (event.keyCode === 40) {
        console.log("向下")
        // 找到current,current+1
        for (let i = 0; i < this.productList.length; i++) {
          if (this.popTableCurrentRow === this.productList[i].id) {
            if (i < this.productList.length - 1) {
              this.popTableCurrentRow = this.productList[i + 1].id;
              console.log("序号: " + (i+1))
              // 上下滚动时，将这条数据滚动出来
              this.popTableScroll(i);
            }
            break;
          }
        }
      } else if (event.keyCode === 38) {
        console.log("向上")
        // 找到current, current-1
        for (let i = 0; i < this.productList.length; i++) {
          if (this.popTableCurrentRow === this.productList[i].id) {
            if (i > 0) {
              this.popTableCurrentRow = this.productList[i - 1].id;
              console.log("序号：" + (i-1))
              // 上下滚动时，将这条数据滚动出来
              this.popTableScroll(i);
            }
            break;
          }
        }
      } else if (event.keyCode === 9) {
        console.log("按tab")
        event.preventDefault();
      } else {
        //
        console.log("其它"+event.keyCode)
      }
    },
    popTableScroll(index) {
      this.$nextTick(() => {
        const tableBodyWrapper = document.querySelector(`#${this.popTableId} .el-table__body-wrapper .el-scrollbar__wrap`);
        if (tableBodyWrapper) {
          tableBodyWrapper.querySelector(`tbody tr:nth-child(${index+1})`).scrollIntoView({behavior: "smooth", block: "center"});
        }
      });
    },
    // 键盘up，用于查询
    inputKeyUp(event, index, words) {
      // eslint-disable-next-line no-empty
      if (event.keyCode === 13 || event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 9) {
      } else {
        //
        this.popTableQuery(words)
      }
    },
    inputClick(event, words, index) {
      // 如果index不一样，重新定位
      if (index !== this.dataListCurrentRowIndex) {
        this.inputBlurEvent = false;
        this.dataListCurrentRowIndex = index;
        this.popTableShow = true;
        this.setPopTablePosition(event);
        let key = words? words.trim() : "";
        if (key === this.popSearchKey && this.popSearchKey !== undefined) {
          // 条件没有变化
          return;
        }
        this.popSearchKey = key;
        this.toPopSearch(); // 查询商品
        return;
      }
      this.dataListCurrentRowIndex = index;
      // 显示popTable
      this.popTableShow = !this.popTableShow;
      if (!this.popTableShow) {
        return;
      }
      // 获取input的定位
      this.setPopTablePosition(event);
      let key = words? words.trim() : "";
      if (key === this.popSearchKey && this.popSearchKey !== undefined) {
        // 条件没有变化
        return;
      }
      this.popSearchKey = key;
      this.toPopSearch(); // 查询商品
    },
    // 显示pop的table以后，进行定位
    setPopTablePosition(event) {
      // 先显示弹框，后定位，不然无法获取尺寸
      document.querySelector(`#${this.popTableId}`).style.left = "9999px";
      this.$nextTick(() => {
        // 获取input的定位
        let rect = event.target.getBoundingClientRect();
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        // 获取弹框的高度
        let popTableHeight = document.querySelector(`#${this.popTableId}`).clientHeight;
        // 如果弹框高度大于剩余高度，则高度设置为剩余高度
        let height = (window.innerHeight - rect.bottom - scrollTop) + 20;
        if (height > popTableHeight) {
          document.querySelector(`#${this.popTableId}`).style.left = rect.left + scrollLeft - 10 + "px";
          document.querySelector(`#${this.popTableId}`).style.top = rect.bottom + scrollTop + 10 + "px";
        } else {
          // 放不下，放到div上面
          document.querySelector(`#${this.popTableId}`).style.left = rect.left + scrollLeft - 10 + "px";
          document.querySelector(`#${this.popTableId}`).style.top = rect.top + scrollTop - popTableHeight - 10 + "px";
        }
      });
    },
    // 从input触发的查询事件
    popTableQuery(words) {
      // 如果上次查询还没有返回，不查询
      if (this.loading) {
        return;
      }
      let key = words? words.trim() : "";
      if (key === this.popSearchKey && this.popSearchKey !== undefined) {
        return;
      }
      this.popSearchKey = key;
      this.toPopSearch(); // 查询商品
    },
    // pop弹框全选/取消全选
    changeInputCheckAll() {
      if (this.popoverCheckAll) {
        // 全选
        for (let i = 0; i < this.productList.length; i++) {
          this.productList[i].checked = true;
        }
      } else {
        for (let i = 0; i < this.productList.length; i++) {
          this.productList[i].checked = false;
        }
      }
    },
    // pop弹框查询数据
    toPopSearch() {
      this.productList = [];
      this.loading = true;
      this.querySkuApi({searchKey: this.popSearchKey}).then(res => {
        this.loading = false;
        this.productList = res.records;
        this.popoverCheckAll = false;
        this.popoverIndeterminate = false;
        // 焦点数据，第一条
        if (this.productList.length > 0) {
          this.popTableCurrentRow = this.productList[0].id;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    queryList() {
      this.querySkuApi(this.searchInfo).then(res => {
        this.searchInfo.totalCount = res.totalCount;
        this.dialogList = res.records;
      })
    },
    // 选中主商品，选中主商品不向table添加数据，直接返回
    selectMainProduct(data) {
      if (this.selectModel === 2) {
        // 选择主商品
        this.$emit("selectOne", data);
        this.showSelect = false;
      }
    },
    // 主商品列表，选中数据变更
    mainTableSelectionChange(list) {
      this.dialogSelected = list;
    },
    // 商品分类查询
    clickCategory(node) {
      this.searchInfo.category = node.dictCode;
      this.resetSearch();
    },
  }
};
</script>

<style lang="scss">
@import "ProductSelectTable";
.product-select-table{
  height: 100%;
  .select-more{
    position: absolute;
    top: 0;
    right: 15px;
    font-size: 20px;
    height: 100%;
    display: none;
  }
  .el-table{
    tr:hover{
      .select-more{
        display: flex;
        align-items: center;
      }
    }
  }
}
.product-select-table.display-not{
  height: auto;
}
.tips{
  font-size: 12px;
  color: #999;
  line-height: 40px;
  margin-right: 20px;
}
</style>